<template>
    <div class="price-tag-product" :class="`price-tag-product--${size}`">
        <div class="price-tag-product__brand">
            {{ product ? product.brand : placeholderText('brand') }}
        </div>
        <div class="price-tag-product__name">
            {{ product ? product.name : placeholderText('name') }}
        </div>
        <div class="price-tag-product__size">
            {{ product ? product.size : placeholderText('size') }}
        </div>
    </div>
</template>

<script setup>
import { usePriceTagText } from '@/js/composables/usePriceTagText';

defineProps({
    product: {
        type: Object,
        default: null,
    },
    size: {
        type: String,
        default: 'large',
    },
});

const { placeholderText } = usePriceTagText();
</script>

<style lang="scss" scoped>
.price-tag-product {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;

    &__brand {
        text-transform: uppercase;
        font-weight: 900;
        font-size: 4.4rem;
    }

    &__name {
        font-size: 2.6rem;
    }

    &__size {
        font-size: 1.6rem;
        font-weight: 700;
    }

    &--medium &__brand {
        font-size: 3.2rem;
    }

    &--medium &__name {
        font-size: 2rem;
    }
}
</style>
